"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldType = void 0;
var FieldType;
(function (FieldType) {
    FieldType["TEXT"] = "text";
    FieldType["TEL"] = "tel";
    FieldType["AMOUNT"] = "amount";
    FieldType["NUMBER"] = "number";
    FieldType["DATE"] = "date";
    FieldType["MASTER"] = "master";
    FieldType["BOOL"] = "bool";
    FieldType["ENUM"] = "enum";
    FieldType["BARCODE"] = "barcode";
    FieldType["ID12"] = "id12";
})(FieldType = exports.FieldType || (exports.FieldType = {}));
